export { default, default as Loader } from './Loader'
export { default as loaderTheme } from './themes/Loader.theme'
export * as LoaderStyles from './styles/Loader.style'

export type { LoaderProps } from './Loader.types'
export type { AppearanceKeys, LoaderTheme } from './themes/Loader.theme.types'
